/** @format */

import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import Vuex from 'vuex'
import router from './router'
import device from 'current-device'
import VueDraggableResizable from 'vue-draggable-resizable'
import {TypeMaps} from './dict';
import wx from "weixin-js-sdk";

Vue.prototype.$wx = wx;
Vue.component('vue-draggable-resizable', VueDraggableResizable)

Vue.prototype.$device = device
import {
    Badge,
    Dialog,
    DatetimePicker,
    Toast,
    Field,
    Col,
    Divider,
    Row,
    Button,
    Cell,
    Checkbox,
    CellGroup,
    Card,
    Form,
    Grid,
    GridItem,
    Image,
    ImagePreview,
    Icon,
    ShareSheet,
    Loading,
    List,
    Lazyload,
    NavBar,
    NumberKeyboard,
    Panel,
    Popup,
    Picker,
    Search,
    Sku,
    Sticky,
    Swipe,
    Switch,
    SwipeItem,
    Sidebar,
    SidebarItem,
    Tabs,
    Tab,
    Tag,
    Tabbar,
    TabbarItem,
    Uploader,
    Empty,
    RadioGroup,
    Radio,
    CheckboxGroup,
    SubmitBar,
    Skeleton,
    Stepper,
    NoticeBar,
    ContactCard,
    GoodsAction,
    GoodsActionIcon,
    GoodsActionButton,
    DropdownMenu, DropdownItem
} from 'vant'

Vue.use(Grid)
    .use(ContactCard)
    .use(NoticeBar)
    .use(Stepper)
    .use(SubmitBar)
    .use(Empty)
    .use(Skeleton)
    .use(CheckboxGroup)
    .use(Divider)
    .use(Dialog)
    .use(DatetimePicker)
    .use(Toast)
    .use(Field)
    .use(Checkbox)
    .use(Form)
    .use(Row)
    .use(Button)
    .use(Cell)
    .use(Col)
    .use(CellGroup)
    .use(Card)
    .use(GridItem)
    .use(Image)
    .use(ImagePreview)
    .use(Icon)
    .use(Switch)
    .use(RadioGroup)
    .use(Radio)
    .use(Loading)
    .use(List)
    .use(Lazyload, {
        lazyComponent: true
    })
    .use(ShareSheet)
    .use(NavBar)
    .use(NumberKeyboard)
    .use(Panel)
    .use(Popup)
    .use(Picker)
    .use(Search)
    .use(Sku)
    .use(Swipe)
    .use(Sticky)
    .use(SwipeItem)
    .use(Sidebar)
    .use(SidebarItem)
    .use(Tabbar)
    .use(Tabs)
    .use(Tab)
    .use(Tag)
    .use(Badge)
    .use(Vuex)
    .use(TabbarItem)
    .use(Uploader)
    .use(GoodsAction)
    .use(GoodsActionIcon)
    .use(GoodsActionButton)
    .use(DropdownMenu)
    .use(DropdownItem)
Vue.config.productionTip = false

function loadJS(url, callback) {

    var script = document.createElement('script'),

        fn = callback || function () {
        };

    script.type = 'text/javascript';


    //IE

    if (script.readyState) {

        script.onreadystatechange = function () {

            if (script.readyState == 'loaded' || script.readyState == 'complete') {

                script.onreadystatechange = null;

                fn();

            }

        };

    } else {

        //其他浏览器

        script.onload = function () {

            fn();

        };

    }

    script.src = url;

    document.getElementsByTagName('head')[0].appendChild(script);

}

if (window.location.href.includes("mode=dev")) {
    loadJS("https://cdnjs.cloudflare.com/ajax/libs/vConsole/3.13.0/vconsole.min.js", function () {
        var vConsole = new VConsole();
        console.log('Hello world');


    });

}
/**
 * Vue.prototype.$http = axios
 */
// axios.defaults.baseURL = 'https://lian.suishou.cc/api/'
// axios.defaults.baseURL = 'http://lian-dev.suishou.cc/api/'
axios.defaults.baseURL = !window.location.protocol.includes("file") ? process.env.VUE_APP_baseURL : "http://" + process.env.VUE_APP_baseURL;
const {origin, host} = window.location;
if (origin.includes("zhilian")) {
    axios.defaults.baseURL = "//" + host + "/api8/"
}
if (window.location.protocol.includes("file")) {
    axios.defaults.baseURL = 'http://lian3dev.suishouecai.com/api/'
}
// axios.defaults.baseURL = 'http://zhilian3.suishou.cc/api8/'
axios.defaults.timeout = 30000
// axios.defaults.withCredentials =true
Vue.prototype.$loading = false
Vue.prototype.$toast = Toast;
Vue.prototype.$baseURL = axios.defaults.baseURL;
axios.interceptors.request.use(
    function (config) {
        let shop_id = store.getters.shop_id
        /*if(store.getters.confirmorderid&&config.headers["Content-Type"]!='multipart/form-data'){
            if(config.method=='post'||config.method=='patch'){
                config.data ={
                    ...config.data,
                    edit:'edit'
                }
            }else if(config.method=='get'||config.method=='delete'){
                config.params ={
                    ...config.params,
                    edit:'edit'
                }
            }
        }*/

        if (!config.hidden_toast) {

            Vue.prototype.$loading = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: config.message || '加载中'
            })
        }

        let requestData = {}
        if (config.data && config.data.nodata) {
            requestData = config.data
        } else {
            requestData['data'] = config.data
        }
        requestData['token'] = {
            customerId: store.getters.user.customerId || 0,
            traderId: store.getters.shop_id || 0,
            userId: store.getters.user.cloudUserId || 0
        }
        if (config.data && config.data.simple) {
            config.data.simple = undefined
            requestData['token'] = undefined
            requestData = config.data
        }
        config.data = requestData
        if (store.getters.token) {
            config.headers['Authorization'] = 'Bearer ' + store.getters.token // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    ({data, headers, url, config}) => {
        // console.log(data,9999)

        Toast.clear()
        // 异常监听
        if (data.status && data.status === 401) { // 401 未登录
            store.dispatch('Logout')
            router.replace('/login')
        } else if (data.status && data.status === 100) {

            Toast(data.message ? data.message : '系统错误')

        } else if (data.success !== true) {
            Dialog.alert({
                title: '提示',
                message: data.message ? data.message : '系统错误'
            }).then(() => {

            })
            // return data
        } else if(data.err === 500) {
            // 需要刷新的错误代码
            store.dispatch('Logout')
            router.replace('/login')

        }
        /*

        if (data.success !== true && data.message == '非法访问') {
            if (Vue.isFobbidenModal) {
                return
            }
            Vue.isFobbidenModal = true;
            Dialog.alert({
                title: '提示',
                showCancelButton: true,
                message: "您确定要退出当前登录，进入新的店铺",
                theme: 'round-button',
            }).then(() => {
                Vue.isFobbidenModal = false;
                store.dispatch('StorageClear');
                window.location.reload();
            }).catch(() => {
                Vue.isFobbidenModal = false;
                let {shop_id} = JSON.parse(localStorage.getItem("user") || '{}');
                store.commit('SET_QUERY_SHOP_ID', shop_id)
                localStorage.setItem("queryShopId", shop_id)
                router.replace('/shop/' + shop_id)
            })
        } else if (data.success !== true) {
            Dialog.alert({
                title: '提示',
                message: data.message ? data.message : '系统错误'
            }).then(() => {
                if (data.status === 401) {
                    // 401 未登录
                    store.dispatch('Logout')
                    router.replace('/login')
                } else if (data.err === 500) {
                    // 需要刷新的错误代码
                    store.dispatch('Logout')
                    router.replace('/login')
                } else {

                }
            })
            // return data
        }
*/
        return data.data
    },
    error => {
        console.log(error)
        if (router.history.current.name == 'land') {
            return
        }
        Vue.prototype.$loading = false
        Toast.clear()
        if (error.code === 'ECONNABORTED') {
            Dialog.alert({
                title: '错误',
                message: '请求超时，请检查网络连接或刷新重试'
            }).then(() => {
                // 需要刷新的错误代码
                window.location.reload()
            })
            return Promise.reject(error)
        }
        if (error.response.data.code === 999) {
            // store.commit('SET_TOKEN', '')
            // router.replace('/login')
            Dialog.confirm({
                title: '请重新登录',
                confirmButtonText: '去登录'
            }).then(() => {
                store.commit('SET_TOKEN', '')
                router.replace('/login')
            })
            return Promise.reject(error)
        }
        if (error.response) {
            console.log('----response----')
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data)
            console.log(error.response.status)
            console.log(error.response.headers)
            console.log('----response----')
        }
        console.log('--------')
        console.dir(error)
        console.dir(error.headers)
        console.dir(error.code)
        console.dir(error.status)
        console.dir(error.message)
        // console.log(error.toJSON());
        console.log('--------')
        Toast.clear()
        Dialog.alert({
            title: '错误',
            message: error ? error : '系统错误'
        }).then(() => {
            // 需要刷新的错误代码
            router.replace('/shop/' + store.getters.shop_id)
        })
        return Promise.reject(error)
    }
)
Vue.prototype.$http = axios
// 状态管理
const store = new Vuex.Store({
    state: {
        confirmorder: {
            vouchers: [],
            comment: "",
            orderid: null,
            sale_discount: ""
        },
        carts: [],
        cartsMianLiao: [],
        menutexts: {},
        price_ratio: 1,
        only_access_specify_design: false,
        token: localStorage.getItem('token'),
        user: localStorage.getItem('user'),
        shop: sessionStorage.getItem('shop'),
        shopId: sessionStorage.getItem('shopId'),
        from_id: sessionStorage.getItem('from_id'),
        queryShopId: localStorage.getItem('queryShopId'),
        designId: 0,
        cartChecked: []
    },
    getters: {
        carts: state => (state.carts ? state.carts : []),
        cartsMianLiao: state => (state.cartsMianLiao ? state.cartsMianLiao : []),
        token: state => (state.token ? state.token : ''),
        confirmorder: state => (state.confirmorder ? state.confirmorder : {}),
        user: state => {
            try {
                let user = state.user ? JSON.parse(state.user) : {}
                user.id = user.id ? user.id : 0
                user.customerId = user.customerId ? user.customerId : 0
                user.traderId = user.traderId ? user.traderId : 0
                user.shop_id = user.shop_id ? user.shop_id : 0
                user.client_id = user.client_id ? user.client_id : 0
                user.name = user.name ? user.name : ''
                user.email = user.email ? user.email : ''
                user.mobile = user.mobile ? user.mobile : ''
                user.type = user.type ? user.type : ''
                user.status = !!user.status
                user.process_steps = user.process_steps ? user.process_steps : []
                user.store_name = user.store_name ? user.store_name : '智帘'
                return user
            } catch (err) {
                sessionStorage.clear()
                Dialog.alert({
                    title: '登录失效',
                    message: '登录失效,请重新登录',
                    confirmButtonText: '去登录'
                }).then(() => {
                    store.dispatch('Logout')
                    router.replace('/login')
                })
            }
        },
        shop: state => {
            try {

                let shop = state.shop ? JSON.parse(state.shop) : {}
                shop.id = shop.id ? shop.id : 0
                shop.name = shop.name ? shop.name : ''
                shop.phone = shop.phone ? shop.phone : ''
                shop.config = shop.config ? shop.config : ''
                shop.contact_person = shop.contact_person ? shop.contact_person : ''
                shop.public_mode = !!shop.public_mode

                return shop
            } catch (err) {
                sessionStorage.clear()
                console.log("店铺信息获取失败333", err);
                Dialog.alert({
                    title: '店铺信息错误',
                    message: '店铺信息获取失败,请先登录',
                    confirmButtonText: '去登录'
                }).then(() => {
                    store.dispatch('Logout')
                    router.replace('/login')
                })
            }
        },

        price_ratio: state => ((store.getters.user.priceDisplayTimes) || 1),

        mode: state => store.getters.shop.public_mode,
        shopId: state => (store.getters.shop.id ? store.getters.shop.id : ''),
        from_id: state => (state.from_id ? state.from_id : ''),
        queryShopId: state => (state.queryShopId ? state.queryShopId : ''),
        shop_id: state => (store.getters.queryShopId ? store.getters.queryShopId : store.getters.shopId),
        designId: state => state.designId,
        cartChecked: state => state.cartChecked,
    },
    mutations: {
        DELETE_CART_ITEM: (state, info) => {
            let [room_index, itemindex] = info.cart_index;
            state.carts[room_index].list.splice(itemindex, 1);
            if (state.carts.list.length == 0) {
                state.carts.splice(room_index, 1)
            }

        },
        ADD_MAINLIAO_CARTS: (state, item) => {
            state.cartsMianLiao = state.cartsMianLiao.concat([item]);
        },
        EDITS_CARTS(state, info) {

            let [room_index, itemindex] = info.cart_index;

            let oldInfo = state.carts[room_index].list[itemindex] || [];
            if (oldInfo.room_name == info.room_name) {
                state.carts = state.carts.map((item1, index) => {
                    if (index == room_index) {
                        state.carts[room_index].list = state.carts[room_index].list.map((item2, index2) => {
                            if (index2 == itemindex) {
                                item2 = info;
                            }
                            return item2;
                        })
                    }
                    return item1
                })

            } else {
                state.carts[room_index].list.splice(itemindex, 1);
                if (state.carts.list.length == 0) {
                    state.carts.splice(room_index, 1)
                }
                this.Store.commit("ADD_CARTS", info)

            }
        },
        ADD_CARTS: (state, item) => {
            const isSameRoom = state.carts.findIndex((item1) => {
                if (item1.list[0]) {
                    if (item1.list[0].room_name == item.room_name) {
                        return true
                    }
                }
                return false

            }) > -1
            if (isSameRoom) {
                state.carts.map((item1) => {
                    if (item1.list[0].room_name == item.room_name) {
                        item1.list = item1.list.concat(item);
                    }
                    return
                })
            } else {
                state.carts = state.carts.concat([{list: [item]}]);
            }
        },
        SET_TOKEN: (state, token) => {
            state.token = token
            localStorage.setItem('token', token)
            console.log('token:', token)
        },
        SET_CONFIRM_ORDER: (state, info = {
            vouchers: [],
            comment: ""
        }) => {
            state.confirmorder = info;
        },
        SET_FROM_ID: (state, from_id) => {
            state.from_id = from_id
            sessionStorage.setItem('from_id', from_id)
            console.log('from_id:', from_id)
        },
        SET_USER: (state, user) => {
            if (user) {
                try {
                    state.user = JSON.stringify(user)
                    localStorage.setItem('user', state.user)
                } catch (err) {
                    console.log('user_err:', err)
                }
            }
            console.log('user:', user)
        },
        SET_SHOP: (state, shop) => {
            if (shop) {
                try {
                    state.shop = JSON.stringify(shop)
                    sessionStorage.setItem('shop', state.shop)
                    sessionStorage.setItem('shopname', shop.name)
                } catch (err) {
                    console.log('shop:', shop)
                    console.log('shop_err:', err)
                }
            }
        },
        SET_QUERY_SHOP_ID: (state, queryShopId) => {
            if (queryShopId) {
                state.queryShopId = queryShopId
                localStorage.setItem('queryShopId', queryShopId)
            }
            console.log('queryShopId:', queryShopId)
        },
        SET_DESIGN_ID: (state, designId) => {
            if (designId) {
                state.designId = designId
            }
        },
        SET_PRICE_RATIO: (state, price_ratio) => {
            if (price_ratio) {
                state.price_ratio = price_ratio
            }
        },
        SET_CART_CHECKED: (state, cartChecked) => {
            if (cartChecked) {
                state.cartChecked = cartChecked
            }
        }
    },
    actions: {
        LoginWithOpenid: ({dispatch}, openid) => {
            axios.post('/user/autologin', {openid, shop_id: store.getters.shop_id}).then(res => {
                if (res && res.user != "no user" && res.api_token) {
                    dispatch('LoginSuccess', res)
                }
            })
        },
        Login: ({dispatch}, userInfo) => {
            // 智帘商城用户验证码自动注册登录
            axios.post(process.env.VUE_APP_USER_baseURL + 'smartCurtain/loginWithVerifyCode', userInfo).then(res => {
                console.log(res, 'login')
                if (res) {
                    dispatch('LoginSuccess', res)
                }
            })
            /*axios.post("http://115.29.142.94:8760/cloud/user/smartCurtain/login",{
                "mobile": "15715577120",
                "password": "12",
                "traderId": 70020,
                simple:true
            }).then((res)=>{
                   if (res) {
                    dispatch('LoginSuccess', res)
                }
            })*/

        },
        LoginSuccess({commit}, res) {

            commit('SET_TOKEN', res.token)
            commit('SET_QUERY_SHOP_ID', res.traderId)
            commit('SET_USER', res)
            commit('SET_FROM_ID', res.id)

            // localStorage.setItem("balance",res.client.deposit_balance)

            /*if (wx && wx.miniProgram) {
                wx.miniProgram.postMessage({ data: { shop_name: res.shop_name } })
            }
            axios.get('/clients/carts/num').then(res => {
                if (res) {
                    localStorage.setItem('cartcount', res)
                }

            })*/
            router.replace('/shop/' + store.getters.shop_id)
        },
        GetShop({commit, state}) {

            /*if (store.getters.shop_id && store.getters.shop_id != 'land') {
                let shop_id = store.getters.shop_id

                return axios.get('/clients/shops/' + shop_id, {
                    hidden_toast: true
                }).then(res => {
                    if (!res || !res.id) {
                        Dialog.alert({
                            title: '店铺信息错误',
                            message: res.message||'店铺信息获取失败,请先登录',
                            confirmButtonText: '去登录'
                        }).then(() => {
                            store.dispatch('Logout')
                            router.replace('/login')
                        })
                    }
                    commit('SET_SHOP', res)

                    if (router.currentRoute.name === 'index') {
                        document.title = res.name
                    }
                })
            }*/
        },
        StorageClear({commit, state}) {
            let shopId = store.getters.shop_id
            sessionStorage.clear()
            localStorage.clear()
            window.sessionStorage.clear()
            window.localStorage.clear()
            if (shopId) {
                commit('SET_QUERY_SHOP_ID', shopId)
            }
        },
        Logout: ({commit, state}) => {
            Toast.clear()
            let is_login = store.getters.token
            store.dispatch('StorageClear')
            localStorage.setItem('cartcount', '')
            commit('SET_TOKEN', '')
            if (is_login) {
                Dialog.alert({
                    title: '提示',
                    message: '您已经退出登录'
                }).then(() => {
                    router.replace('/login')
                })
            } else {
                router.replace('/login')
            }
        }
    }
})
var _hmt = _hmt || []
window._hmt = _hmt // 修改为window 全局变量
;
/*(function() {
    var hm = document.createElement('script')
    hm.src = "https://hm.baidu.com/hm.js?fd16fe48f6f4f2c88f0465a5be77a0c6"
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
})()*/

router.beforeEach((to, from, next) => {
    Vue.prototype.$loading = false;
    if (!store.getters.token && store.getters.shop_id) {
        var openid = getQueryVariable("openid") || undefined;
        if (openid) {
            sessionStorage.setItem("openid", openid)
            store.dispatch("LoginWithOpenid", openid)
        }

    }
    if (to.path === '/login') {
        // sessionStorage.clear()
        if (store.getters.token && store.getters.shop_id) {
            next({
                path: '/shop/' + store.getters.shop_id
            })
            return false
        }
        // store.dispatch('StorageClear')
        next()
    } else if (to.meta.is_login && !store.getters.token) {
        Dialog.confirm({
            title: '请先登录',
            confirmButtonText: '去登录'
        }).then(() => {
            store.dispatch('Logout')
            next({
                path: '/login'
            })
        })
    } else {
        // from_id
        if (from.query.from_id && store.getters.from_id != from.query.from_id) {
            store.commit('SET_FROM_ID', from.query.from_id)
        } else if (to.query.from_id && store.getters.from_id != to.query.from_id) {
            store.commit('SET_FROM_ID', to.query.from_id)
        }
        // shop_id
        if (from.query.shop_id && store.getters.queryShopId != from.query.shop_id) {
            store.commit('SET_QUERY_SHOP_ID', from.query.shop_id)
        } else if (to.query.shop_id && store.getters.queryShopId != to.query.shop_id) {
            store.commit('SET_QUERY_SHOP_ID', to.query.shop_id)
        } else if (to.params.shop_id && store.getters.queryShopId != to.params.shop_id) {
            store.commit('SET_QUERY_SHOP_ID', to.params.shop_id)
        } else if (from.params.shop_id && store.getters.queryShopId != from.params.shop_id) {
            store.commit('SET_QUERY_SHOP_ID', from.params.shop_id)
        } else if (!store.getters.shop_id && from.path.indexOf("clients") != -1) {
            Dialog.alert({
                title: '店铺未知',
                message: '请登录后访问',
                confirmButtonText: '去登录'
            }).then(() => {
                store.dispatch('Logout')
                next({
                    path: '/login'
                })
            })
            return false
        }
        if (!to.params.shop_id && store.getters.shop_id && ['default', 'index'].indexOf(to.name) !== -1) {
            next({path: '/shop/' + store.getters.shop_id, replace: true})
        } else if (!to.query.from_id && store.getters.from_id) {
            let query = to.query
            query.from_id = store.getters.from_id;
            next({
                path: to.path,
                query: to.query
            })
            // next({
            //     path: to.path + '?from_id=' + store.getters.from_id
            // })
        } else if (!store.getters.shop || store.getters.shop.id != store.getters.shop_id) {
            store.dispatch('GetShop')
        }
        // mode === 1时 任何人都可以访问所有不需要登录的页面
        // mode === 0时 必须登录 并且 shop_id === queryShopId 才能访问所有页面
        if (store.getters.shop && store.getters.shop.id && !store.getters.mode && ['default', 'index'].indexOf(to.name) !== -1) {
            if (!store.getters.token) {
                Dialog.confirm({
                    title: '隐私模式',
                    message: '请登录后，再访问其他页面',
                    confirmButtonText: '去登录'
                }).then(() => {
                    store.dispatch('Logout')
                    next({
                        path: '/login',
                        replace: true
                    }) // on confirm
                })
                return false
            } else if (store.getters.shop_id != store.getters.shop.id) {
                Dialog.alert({
                    title: '隐私模式',
                    message: '只能访问当前店铺'
                })
                return false
            }
        }
        if (window._hmt && to.path) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
        // window.scrollTo(0, 200);
        if (!to.path.includes('confirmOrder') && !to.path.includes('address')) {
            store.commit('SET_CONFIRM_ORDER')
        }
        next()
    }
})
router.afterEach((to, from, next) => {
    Vue.prototype.$loading = false
    if (to.name != 'index') {
        let v = to.meta.title;


        document.title = v
    }

})
// try {
//     var shop_id2 = window.location.hash.split("?")[0].split("/")[2];
//     if (shop_id2) {
//     axios.get('/clients/shops/' + shop_id2).then(res => {
//         if (res) {
//             // if (router.currentRoute.name === 'index') {
//                 document.title = res.name
//                 // state.user = JSON.stringify(res.user)
//                 localStorage.setItem('shopname', res.name)
//             // }
//         }

//     })
//     }
// } catch (error) {

// }
function getQueryVariable(variable) {

    var query = window.location.hash.substring(1);

    var vars = query.split("&");
    var ret = false;
    for (var i = 0; i < vars.length; i++) {

        var pair = vars[i].split("=");
        if (pair[0].includes(variable)) {
            ret = pair[1];
            break;
        }

    }

    return ret;

}

Vue.prototype.$setMenuText = (callback) => {
    let that = this;
    let config = JSON.parse(sessionStorage.getItem("shop") || '{}').config || {}

    if (Object.keys(config).length > 0) {
        store.state.menutexts = config.smart_curtain_alias


        callback && callback(config.smart_curtain_alias);
    } else {

        store.dispatch("GetShop").then((res) => {
            config = JSON.parse(sessionStorage.getItem("shop") || '{}').config || {}
            store.state.menutexts = config.smart_curtain_alias

            callback && callback(config.smart_curtain_alias);
        })
    }
}
Vue.prototype.returnCommonObj = function (items = [], id, text, memo = "") {
    items = items.map((item) => {
        if (memo) {

            return {
                ...item,
                id: item[id],
                text: item[text],
                memo: item.memo
            }
        }
        return {
            ...item,
            id: item[id],
            text: item[text]
        }
    })
    return items
}
Vue.prototype.setPriceRatio = function (v = '', price_ratio = store.getters.price_ratio) {

    if (v && v != 0 && v != '') {
        v = v + ''
        v = parseFloat(v.replace("¥", ""))
        return Number(v * (price_ratio || 1)).toFixed(2);
    } else if (v == 0) {
        return 0
    } else if (v == '' || v == null) {
        return ''
    }

}
Vue.prototype.getQueryVariable = getQueryVariable;
Vue.prototype.$can = permission => {
    return store.getters.permissions.indexOf(permission) > -1
}
Vue.prototype.price_ratio = (v, type) => {
    if (store && !store.getters.token) {
        v = Number((store.getters.user.priceDisplayTimes || 1) * v) || (type == 2 ? 0 : '');
    }
    /*if (store && store.getters.shop.config.smart_curtain_sale_price_odd == 'round') {
        v = Math.round(v)
    }
    if (store && store.getters.shop.config.smart_curtain_sale_price_odd == 'floor') {
        v = Math.floor(v)

    }*/
    return v;

}

Vue.prototype.AddCartMethods = {
    setPropertyActive(name, value, text, label, ismulti = false, memo) {
        let that = this;

        if (!ismulti) {
            that.designInfo.list[name] = that.designInfo.list[name] || {}
            that.designInfo.list[name] = {value, text, label, memo};
            // this.$set(that.designInfo.list,[name], {value, text, label,memo})
        } else {
            that.designInfo.list[name] = that.designInfo.list[name] || []
            that.designInfo.list[name] = [{value, text, label, memo}];
            // this.$set(that.designInfo.list,[name], [{value, text, label,memo}])
        }
        this.$forceUpdate()
    },
    setDefaultData(keeyColorStyle = false,param = []) {
        let that = this;
        // debugger
        this.designInfo.room_name = this.designInfo.room_name || this.fieldData[0].items[0].text
        this.fieldData.forEach((item) => {

            let $item = param[item.name];
            if($item) {
                let id = $item.id || $item.value
                let text = $item.text
                this.setPropertyActive(item.name, id, text, item.label, item.ismulti, $item.memo ?? null);
            } else if (item.items && item.items.length > 0 && !keeyColorStyle && item.required) {
                let $item = item.items[0]
                let id = $item.id || $item.value
                let text = $item.text
                this.setPropertyActive(item.name, id, text, item.label, item.ismulti, $item.memo);
            }
        })
    },
    getStyleData(id, customerDesignId = 0, isSetData = true, keeyColorStyle = false,productId = 0) {
        return new Promise((reslove) => {
            this.$http.post("/public/designDetail", {
                "designId": id,
                "productId": productId,
                "customerDesignId": customerDesignId,
            }).then(async res => {
                // debugger
                res = res || {}
                this.imgs = this.imgs || []
                this.imgs = this.imgs.filter((item) => res[item])
                this.design = res || {}
                this.designInfo.list = this.designInfo.list || {}

                this.designInfo.imageOne = res.imageOne;// 款式场景图
                this.designInfo.name = res.name;
                this.designInfoTemp = {
                    ...this.designInfo,
                    qiangkuan: this.designInfoTemp.qiangkuan,
                    liangao: this.designInfoTemp.liangao
                }
                this.dapeiList = res.collocationDesignList || [];// 大屏列表
                this.zhubuList = res.productList || [];// 订单主布列表
                for (let i = 0; i < this.fieldData.length; i++) {
                    let item = this.fieldData[i];
                    const typeMap = TypeMaps[item.label] || {}
                    if (typeMap.arrayName) {
                        let defaultItem = [];
                        if (item.label == '颜色分类' && !keeyColorStyle) {
                            defaultItem = [{number: res.name, colorImageUrl: res.imageOne, id: res.id}]
                        }
                        if (!keeyColorStyle) {
                            item.items = defaultItem.concat(res[typeMap.arrayName] || [])
                            item.items = this.returnCommonObj(item.items, typeMap.idName, typeMap.textName)
                        }

                    }
                    /*if (item.label == '面料方向' && !res.processType ) {
                        item.items = []
                    }else if (item.label == '面料方向' ) {
                        // item.items = [{
                        //     text: res.zhuBuDesignTypeName,
                        //     value: res.zhuBuDesignType
                        // }]
                    }*/


                    if(res.designCategory != 'LianTou') {
                        if (item.label == '粘贴方向' || item.label == '转角' ) {
                            item.items = []
                        }
                        if (item.label == '分片方式') {
                            let res = await this.$http.post("/public/openModes")
                            item.items = res || []

                            item.items = this.returnCommonObj(item.items, typeMap.idName, typeMap.textName, true)
                        }

                    }
                    if(res.designCategory == 'LianTou') {

                        if (item.label == '转角' ) {
                            item.items = [{
                                text: "左转角",
                                value: res.leftRadian || '',
                                name: "leftRadian"
                            }, {
                                text: "右转角",
                                value: res.rightRadian || '',
                                name: "rightRadian"
                            }]
                            this.designInfo.leftRadian = res.leftRadian || ''
                            this.designInfo.rightRadian = res.rightRadian || ''
                        }

                        if(item.label == '分片方式' || item.label == '加工方式' || item.label == '面料方向' || item.label == '复杂加工' || item.label == '绑带' || item.label == '颜色分类'|| item.label == '褶倍') {
                            item.items = []
                        }
                    }

                }


                if(isSetData) {


                    let jiagongfangshi = res.installationCraft ? {
                        text: res.installCraftName,
                        value: res.installationCraft,
                    } : null
                    let pleatTimes = res.pleatTimesId ? {
                        text: res.pleatTimesName,
                        value: res.pleatTimesId,
                    } : null
                    let fenpianfangshi = res.openMode ? {
                        text: res.curtainOpenModeName,
                        value: res.openMode,
                        memo: '',
                    } : null

                    let param = {
                        // selectRoom: this.designInfo.room_name || this.fieldData[0].items[0].text,
                        // mianliaoDir: {
                        //     text: res.processType == 'FixWidth' ? '买高' : '买宽',
                        //     value: res.processType == 'FixWidth' ? 'FixWidth' : 'FixHeight',
                        // },
                        jiagongfangshi: jiagongfangshi,
                        pleatTimes: pleatTimes,
                        fenpianfangshi: fenpianfangshi,
                        /*pasteDirection: {
                            text: res.selectedPasteDirection.optionDesc,
                            value: res.selectedPasteDirection.optionValue,
                        }
                        fuzhaJiagong: selectedExpandItems,
                        bangdai: {
                            value: res.bangDaiProductId,
                            text: res.bangDaiProductNumber,
                        },*/
                    };


                    if(res.designCategory == 'LianTou') {

                        let pasteDirectionSelect = [];
                        if(res.pasteDirectionType) {
                            res.pasteDirectionList.map((item)=>{
                                if(item.optionValue == res.pasteDirectionType) {
                                    pasteDirectionSelect = {
                                        text:item.optionDesc,
                                        value:item.optionValue,
                                    }
                                }
                            })

                            param = {
                                pasteDirection: pasteDirectionSelect
                            }
                        }


                    }
                    // console.log(param)

                    isSetData && this.setDefaultData && this.setDefaultData(keeyColorStyle,param);

                    // console.log(this.fieldData);
                }

                document.title = this.design.name || this.design.zhuBuProductName


                // debugger
                reslove();
                // 购物车模型


            })
        })

    },
    getEditStyleData(res) {
        return new Promise(async (reslove) => {
            res = res || {}
            this.imgs = this.imgs || []
            this.imgs = this.imgs.filter((item) => res[item])
            this.design = res || {}
            this.designInfo.id = this.design.id
            this.designInfo.list = this.designInfo.list || {}

            this.designInfo.imageOne = res.designImageUrl;// 款式场景图
            this.designInfo.name = res.name;
            this.designInfoTemp = {
                ...this.designInfo,
                qiangkuan: this.designInfoTemp.qiangkuan,
                liangao: this.designInfoTemp.liangao
            }
            this.dapeiList = res.collocationDesignList || [];// 大屏列表
            this.zhubuList = res.productList || [];// 订单主布列表
            for (let i = 0; i < this.fieldData.length; i++) {
                let item = this.fieldData[i];
                const typeMap = TypeMaps[item.label] || {}
                if (typeMap.arrayName) {
                    let defaultItem = [];
                    if (item.label == '颜色分类') {
                        defaultItem = [{number: res.name, colorImageUrl: res.imageOne, id: res.id}]
                    }
                    item.items = defaultItem.concat(res[typeMap.arrayName] || [])
                    item.items = this.returnCommonObj(item.items, typeMap.idName, typeMap.textName)


                }
                /*if (item.label == '面料方向' && !res.processType ) {
                    item.items = []
                }else if (item.label == '面料方向' ) {
                    // item.items = [{
                    //     text: res.zhuBuDesignTypeName,
                    //     value: res.zhuBuDesignType
                    // }]
                }*/


                if(res.designCategory != 'LianTou') {
                    if (item.label == '粘贴方向' || item.label == '转角' ) {
                        item.items = []
                    }
                    if (item.label == '分片方式') {
                        let result = await this.$http.post("/public/openModes")
                        item.items = result || []

                        item.items = this.returnCommonObj(item.items, typeMap.idName, typeMap.textName, true)
                    }

                }
                if(res.designCategory == 'LianTou') {

                    if (item.label == '转角' ) {
                        item.items = [{
                            text: "左转角",
                            value: res.leftRadian || '',
                            name: "leftRadian"
                        }, {
                            text: "右转角",
                            value: res.rightRadian || '',
                            name: "rightRadian"
                        }]
                        this.designInfo.leftRadian = res.leftRadian || ''
                        this.designInfo.rightRadian = res.rightRadian || ''
                    }

                    if(item.label == '分片方式' || item.label == '加工方式' || item.label == '面料方向' || item.label == '复杂加工' || item.label == '绑带' || item.label == '颜色分类'|| item.label == '褶倍') {
                        item.items = []
                    }
                }

            }

            document.title = this.design.name || this.design.zhuBuProductName

            // debugger
            reslove();
            // 购物车模型
        })

    },
    onClickButton() {

        this.designInfoTemp = {...this.designInfo}
        this.showDetailModal = true;
    },
    setModalState(v) {
        this.showDetailModal = v
    },
    editDesignInfo(info, type = 'edit', isColorType, index) {

        try {
            info.designId = this.design.id;
            if (type == 'edit') {
                this.designInfoTemp = {...info}
            } else {

                this.designInfo = info;
                this.$store.commit("ADD_CARTS", this.designInfo);
                // console.log(this.$store.getters.carts)
                Toast('加入购物车成功！');
            }
            if (isColorType && info.list.colorType.value) {
                // 款式 颜色分类，选择当前款式 或者选择单色
                if (index == 0) {
                    this.getStyleData(this.$store.getters.designId, 0, true, true);
                } else { // 保留当前款式
                    this.getStyleData(0, 0, true, true,info.list.colorType.value);
                }

            }
        } catch (err) {
            console.log('user_err:', err)
        }
    }
}
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
